import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiTableStyles = {
    styleOverrides: {
        root: {
            '&.import-table': {
                marginBottom: '4px',
                '& .MuiTableCell-root': {
                    borderColor: `${Palette.gray.gray100} !important`,
                    borderLeft: `2px solid ${Palette.gray.gray100}`,
                    borderWidth: '2px',
                    fontSize: '11px',
                    fontWeight: '400',
                    lineHeight: '12px',
                    color: Palette.black,
                    padding: '16px 20px',
                },
                '& .MuiTableHead-root': {
                    '& .MuiTableRow-root': {
                        '& .MuiTableCell-head': {
                            backgroundColor: Palette.gray.gray100,
                            fontWeight: '600',
                        },
                    },
                },
                '& .MuiTableBody-root': {
                    '& .MuiTableRow-root': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '& .MuiTableCell-body': {
                            '& .table-cell-content': {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                whiteSpace: 'nowrap',
                                '& svg': {
                                    width: '16px',
                                    minWidth: '16px',
                                    height: '16px',
                                },
                            },
                        },
                    },
                },
                '& + .MuiTablePagination-root': {
                    border: 'none !important',
                    paddingLeft: '45px',
                    '& .MuiToolbar-root': {
                        border: 'none !important',
                    },
                },
            },
        },
    },
};
